import {initFindCivicAddressesForm} from "./find-civic-addresses-form.mjs";

(function ($, Drupal, drupalSettings, once) {

  'use strict';

  Drupal.behaviors.promutuel_find_civic_addresses = {
    attach: function attach(context) {

      // Close find addresses form.
      const returnToggler = document.querySelectorAll('.js-fcaddresses-return');
      returnToggler.forEach(el => {
        el.addEventListener('click', function handleClick(event) {
          el.closest('.js-slocpanel-personalinfo').classList.remove('js-sloc-active-form--find-addresses');
          emptyForm();
        });
      });

      // Send selected address to main form.
      $('.js-slocpanel-personalinfo').on('click', '.fcaddresses-list li' ,function () {
        $('.js-slocpanel-personalinfo').each(function () {
          $(this).removeClass('js-sloc-active-form--find-addresses');
          $('.fcaddresses-list').innerHTML = '';
        });
        if ($(this).hasClass('js-fcaddresses-not-found')) {
          // Back to main form and remove initial value.
          $('#topnavstorelocator__address').val('');
          $('#claimbyphone__address').val('');
        }
        else {
          // Send selected address to main form.
          let address = $(this).text();
          $('#topnavstorelocator__address').val(address);
          $('#claimbyphone__address').val(address);
        }
        // Empty form when leaving.
        emptyForm();
      });
    }
  }

  Drupal.behaviors.promutuel_storeLocatorAddress = {
    attach: function attach(context) {
      const container = document.querySelector('.js-slocpanel-fcaddresses');

      // Exit on pages where the container does not exist.
      if (!container) return;

      $(once('promutuelstoreLocatorAddress', container, context)).each(function () {

        const form = document.querySelector('.js-fcaddresses-form');

        const onAddressesFound = function (data) {
          return data;
        };
        const onAddressesNotFound = function (err) {
          return err;
        };

        initFindCivicAddressesForm(container, {
          idPrefix:   'fcaddresses',
          onsuccess: onAddressesFound,
          onfailure: onAddressesNotFound,
          buttonText: Drupal.t('Click here if your address does not appear'),
        });
     });
    }
  }

  // Empty Find my address form.
  function emptyForm() {

    const prefixes = [
      'fcaddresses',
      'claim-fcaddresses'
    ];

    // We have different address autocomplete fields.
    prefixes.forEach( (el) => {
      document.querySelector(`#${el}__input-civic-number`).value = '';
      document.querySelector(`#${el}__input-postalcode`).value = '';
      document.querySelector(`.js-${el}-list`).innerHTML = '';
    });
  }

})(jQuery, Drupal, drupalSettings, once);
